import { FC, ReactNode } from 'react';
import classNames from 'classnames';

import styles from './CardBody.module.scss';

export type CardBodyProps = {
  children?: ReactNode;
  className?: string;
};

export const CardBody: FC<CardBodyProps> = ({ children, className }) => {
  return <article className={classNames(className, styles.cardBody)}>{children}</article>;
};
